import wcbtListProduct from './wishlist/product-list';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	wcbtListProduct();
} );
